module.exports = __webpack_public_path__ + "img/parliament-3.b6866f76.webp";